/**
 * Vuex module to sort SMS conversations
 */

import ChatLocalStorage from '@/api/chat'

const actions = {
  setProperty ({ commit }, property) {
    commit('SET_PROPERTY', property)
    ChatLocalStorage.setChannelsSortProperty(property)
    this.dispatch('chat/ChannelsSortByFilter/sortChannels')
  },
  setDirection ({ commit }, direction) {
    commit('SET_DIRECTION', direction)
    ChatLocalStorage.setChannelsSortDirection(direction)
    this.dispatch('chat/ChannelsSortByFilter/sortChannels')
  },
  sortChannels () {
    this.dispatch('chat/getChannels')
  },
  init ({ commit }) {
    commit('SET_PROPERTY', ChatLocalStorage.channelsSortProperty())
    commit('SET_DIRECTION', ChatLocalStorage.channelsSortDirection())
  }
}

const mutations = {
  SET_PROPERTY (state, property) {
    state.property = property
  },
  SET_DIRECTION (state, direction) {
    state.direction = direction
  }
}

const state = {
  directions: ['asc', 'desc'],
  property: 'recent_activity',
  direction: 'asc'
}

const getters = {
  directions: state => state.directions,
  property: state => state.property,
  direction: state => state.direction
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
